module.exports = __webpack_public_path__ + "static/media/flowers.938041e3.jpg";